import React, { Component } from 'react';
import { minWidth, tablet, phoneMedium } from '../screenSizes';
import { getWindow } from '../globals';
import { Image } from './Image';
import { Button } from './Button';
import { largeMargin, gutter } from '../margins';

export class LogoWithButtons extends Component {
  componentDidMount() {
    if (!this.leftButton) {
      return;
    }

    setTimeout(() => {
      let { clientWidth: leftWidth } = this.leftButton;
      let { clientWidth: primaryWidth } = this.primaryButton;

      if (leftWidth > primaryWidth) {
        this.primaryButton.style.width = leftWidth + 'px';
      } else {
        this.leftButton.style.width = primaryWidth + 'px';
      }
    }, 200);
  }

  render() {
    const { logo, leftButton, primaryButton } = this.props;
    const logoWidth =
      getWindow() && getWindow().innerWidth * 0.7 < 700
        ? getWindow().innerWidth * 0.7
        : 700;
    return (
      <div
        css={`
          display: flex;
          justify-content: center;
          align-items: center;
          align-content: center;
          flex-wrap: wrap;
          width: 100%;
          margin-left: ${gutter};
          margin-right: ${gutter};
          max-width: 700px;

          ${minWidth(tablet)} {
            width: 70%;
          }
        `}
      >
        <Image
          css={`
            margin-bottom: ${largeMargin};
          `}
          src={logo.url}
          alt={logo.alt}
          cloudinaryOptions={logo.cloudinary}
          width={logoWidth}
        />
        <div
          css={`
            width: 100%
            display: flex;
            justify-content: space-between;
            align-content: center;
            
            ${minWidth(phoneMedium)} {
              justify-content: center;
            }
          `}
        >
          {leftButton && (
            <Button
              innerRef={leftButton => (this.leftButton = leftButton)}
              css={`
                font-weight: 400;

                ${minWidth(phoneMedium)} {
                  margin: 0 ${gutter};
                }
              `}
              bright
              href={leftButton.href}
            >
              {leftButton.text}
            </Button>
          )}
          <Button
            innerRef={primaryButton => (this.primaryButton = primaryButton)}
            css={`
              font-weight: 400;

              ${minWidth(phoneMedium)} {
                margin: 0 ${gutter};
              }
            `}
            primary
            href={primaryButton.href}
          >
            {primaryButton.text}
          </Button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/LogoWithButtons.js